import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Alert,
  CircularProgress, Table, TableHead, TableBody, TableRow, TableCell,
} from "@mui/material";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const EligibleForfaits = () => {
  const [patientId, setPatientId] = React.useState("");
  const [proId, setProId] = React.useState("");
  const [list, setList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const search = async () => {
    if (!patientId.trim() || !proId.trim()) return;
    setLoading(true);
    try {
      // professionalId est un @RequestParam obligatoire côté backend
      const params = new URLSearchParams({ patientId, professionalId: proId });
      const { json } = await httpClient(`${API_BASE_URL}/forfaits/eligible?${params}`);
      setList(Array.isArray(json) ? json : json?.data || []);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <EventAvailableIcon /> Forfaits éligibles à un RDV
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Liste les forfaits actifs d'un patient pouvant couvrir une nouvelle consultation.
      </Alert>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Stack direction="row" spacing={2}>
            <TextField size="small" label="ID patient" value={patientId}
              onChange={(e) => setPatientId(e.target.value)} />
            <TextField size="small" label="ID pro" value={proId}
              onChange={(e) => setProId(e.target.value)} />
            <Button variant="contained" onClick={search}
              disabled={loading || !patientId.trim() || !proId.trim()}>
              {loading ? <CircularProgress size={18} /> : "Lister"}
            </Button>
          </Stack>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Pro</TableCell>
                <TableCell>Séances</TableCell>
                <TableCell>Restantes</TableCell>
                <TableCell>Statut</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.length === 0 ? (
                <TableRow><TableCell colSpan={5} align="center">Aucun forfait éligible</TableCell></TableRow>
              ) : list.map((f, i) => (
                <TableRow key={f.id || i}>
                  <TableCell>{f.id}</TableCell>
                  <TableCell>{f.proId}</TableCell>
                  <TableCell>{f.sessionsCount}</TableCell>
                  <TableCell>{(f.sessionsCount || 0) - (f.sessionsUsed || 0)}</TableCell>
                  <TableCell>{f.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: EligibleForfaits };
